import clsx from 'clsx';
import Link from 'next/link';
import { type } from 'os';
import React, { memo } from 'react';

interface BaseLinkProps {
  type: 'internal' | 'external';
  Icon?: React.FC<any>;
  label: string;
  className?: string;
  iconClassName?: string;
  props: any;
}

const BaseLink = ({ type, label, Icon, className, iconClassName, props }: BaseLinkProps) => {
  const LinkComponent = type === 'internal' ? Link : 'a';

  return (
    <LinkComponent
      {...props}
      className={clsx(
        'flex items-center gap-1 rounded-full text-sm font-medium hover:text-sky-600',
        className,
      )}
    >
      {Icon ? <Icon className={clsx('h-5 w-5 text-primary-500', iconClassName)} /> : null}
      {label}
    </LinkComponent>
  );
};

export default memo(BaseLink);
